export const paginationBlockStyle = 'py-m @lg:px-lg px-m rounded-md cursor-pointer text-center min-w-10 @lg:min-w-0 hover:bg-primary-hover hover:text-white';
//# sourceMappingURL=paginationBlockStyle.js.map